import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useKnowledgeBaseCategory, KnowledgeBaseCategory } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<KnowledgeBaseCategory>
      useData={useKnowledgeBaseCategory}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
